import { Base } from "ui/Scripts/source/framework/base";
import { CompanyListItem } from "../company/companyListItem";

export interface IModulePartnerListItem {
    id: string;
    partnerCompanyId: string;
    code: string;
    name: string;
    logo: string;
    activeState: number;
    unitId: string;
    unit: string;

    activeStateStr: string;
}

export class ModulePartnerListItem implements IModulePartnerListItem {
    id: string;
    partnerCompanyId: string;
    code: string;
    name: string;
    logo: string;
    activeState: number;
    unitId: string;
    unit: string;

    activeStateStr: string;

    constructor();
    constructor(obj: IModulePartnerListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.partnerCompanyId = obj && obj.partnerCompanyId || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.logo = obj && obj.logo || "";
        this.activeState = obj && obj.activeState || 0;
        this.unitId = obj && obj.unitId || "";
        this.unit = obj && obj.unit || "";

        this.activeStateStr = CompanyListItem.getActiveStateToStr(this.activeState);
    }

    static sortModulePartnerListItemss(items: IModulePartnerListItem[], column: string, asc: boolean): IModulePartnerListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "name") {
            return items.sort((a: IModulePartnerListItem, b: IModulePartnerListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        } else if (column === "activeState") {
            return items.sort((a: IModulePartnerListItem, b: IModulePartnerListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        } else if (column === "unit") {
            return items.sort((a: IModulePartnerListItem, b: IModulePartnerListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.unit, b.unit)); });
        } else {
            return items.sort((a: IModulePartnerListItem, b: IModulePartnerListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}